import { call, put, takeLatest } from "redux-saga/effects";
import { attributesApi } from "../api/attributesApi";
import { Action } from "redux";
import { AttributeListSectionFetchAction } from "../../actions/action_creators";
import { setSnackbar } from "@src/store/generals/actionCreators";
import { getRequestError } from "@src/utils/getRequestError";
import { AttributeListSectionActionTypes } from "../../actions/types";

export function* allAttributesListSectionSaga() {
  yield takeLatest(
    AttributeListSectionActionTypes.FETCH_ATTRIBUTES_FROM_IIKO_START_SAGA,
    getAttributesFromIIKO
  );
}

export function* getAttributesFromIIKO(
  action: AttributeListSectionFetchAction
) {
  try {
    yield put({ type: AttributeListSectionActionTypes.START_LOADING });
    const { data } = yield call(
      attributesApi.getAttributesFromIIKO,
      action.payload
    );

    yield put({
      type: AttributeListSectionActionTypes.SUCCESS,
      payload: data.attribute_groups,
    });
  } catch (e) {
    yield put(
      setSnackbar({
        status: "error",
        message: getRequestError(e),
        visible: true,
      })
    );
  }
}
